import React, { useEffect } from 'react'
import axios from 'axios'
import { InsightContentSettingType } from 'components/insightContent/types'
import { createPhotoSearch } from 'utils/runSearchUtil'
import ServiceType from 'enums/ServiceType'
import { useAppDispatch } from 'app/hooks'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { ERROR_MESSAGE } from 'features/insightContent/insightContentSlice'

const createSearch = (detailSetting: InsightContentSettingType) => {
  const { topicId, selectionFilter, precision } = detailSetting
  const { recognizedMedias } = selectionFilter
  const recognizedMedia = recognizedMedias?.[0]?.[0]

  return createPhotoSearch(
    -1,
    '',
    [topicId],
    selectionFilter,
    precision,
    recognizedMedia?.type || '',
    (recognizedMedia?.names as string[]) || [],
    30,
    ServiceType.SW_PHOTO_CONCEPTS
  )
}

const RunSearchEffect = ({
  detailSetting,
  children
}: {
  detailSetting: InsightContentSettingType
  children: React.ReactNode
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const search = createSearch(detailSetting)

    // eslint-disable-next-line prefer-destructuring
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.PHOTO_CONCEPT,
        searches: [search],
        timestamp: refreshTimestamp,
        requestConfig: {
          cancelToken: source.token
        }
      })
    )

    return () => {
      // Avoid race condition by cancelling the request when the component is remounted or unmounted.
      source.cancel(ERROR_MESSAGE.REQUEST_CANCELLED)
    }
  }, [dispatch, detailSetting, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
